import { Component, Input, OnInit } from '@angular/core';
import { UniApiConfig } from '@sparro/app/core/config/api.config';
import { Publication } from '@sparro/app/core/models/publication.model';
import { environment } from '@sparro/env/environment';

@Component({
  selector: 'uni-publication-card-footer',
  templateUrl: './publication-card-footer.component.html',
  styleUrls: ['./publication-card-footer.component.scss']
})
export class PublicationCardFooterComponent implements OnInit {
  @Input() publication: Publication;
  @Input() footerType: string;
  source: string;

  constructor(
    private _apiConfig: UniApiConfig
  ) { }

  ngOnInit() {
    this.source = this._apiConfig.publicationUrl;
  }
  goToTopic(slug: string): string {
    return `${environment.topicUrl}${slug}`;
  }
}
